<header class="app-header">
  <img src="/assets/logoMenu.png" alt="Logo" >
</header>
<main class="page-container">
  <router-outlet></router-outlet>
</main>
